import { PreferredNetworkOtaspResponseBody } from "../../entities/preferred-network-and-otasp-v1/preferred-network-otasp-response-body";

export enum PreferredNetworkAndOTASPActionNames {
  SET_PREFERRED_NETWORK_STATUS = 'SET_PREFERRED_NETWORK_STATUS',
  ACTIVATE_OTASP = 'ACTIVATE_OTASP' 
}

export interface PreferredNetworkAndOTASPState {
  preferredNetworkDetails: PreferredNetworkOtaspResponseBody | undefined;
}

interface SetPreferredNetworkAction {
  type: typeof PreferredNetworkAndOTASPActionNames.SET_PREFERRED_NETWORK_STATUS;
  payload: PreferredNetworkOtaspResponseBody
}

interface SetOTASPActivateAction {
  type: typeof PreferredNetworkAndOTASPActionNames.ACTIVATE_OTASP;
  payload: PreferredNetworkOtaspResponseBody
}

export type PreferredNetworkAndOTASPActionTypes = 
  SetPreferredNetworkAction |
  SetOTASPActivateAction;